/* eslint-disable no-param-reassign */

const store = {
  state: {
    containerLocked: false,
    negativeLayout: false,
    language: "en",
    loading: false,
    currentFilter: null,
    lastWindowPosition: 0,
  },

  mutations: {
    SET_CONTAINER_LOCKED(state, action) {
      state.containerLocked = action;
    },

    SET_NEGATIVE_LAYOUT(state, action) {
      state.negativeLayout = action;
    },

    SET_LANGUAGE(state, action) {
      state.language = action;
    },

    SET_LOADING(state, action) {
      state.loading = action;
    },

    SET_FILTER(state, action) {
      state.currentFilter = action;
    },

    SET_WINDOW_POSITION(state, action) {
      state.lastWindowPosition = action;
    },
  },

  actions: {
    setContainerLocked({ commit }, action) {
      commit("SET_CONTAINER_LOCKED", action);
    },

    setNegativeLayout({ commit }, action) {
      commit("SET_NEGATIVE_LAYOUT", action);
    },

    setLanguage({ commit }, action) {
      commit("SET_LANGUAGE", action);
    },

    setLoading({ commit }, action) {
      commit("SET_LOADING", action);
    },

    setFilter({ commit }, action) {
      commit("SET_FILTER", action);
    },

    setWindowPosition({ commit }, action) {
      commit("SET_WINDOW_POSITION", action);
    },
  },
};

export default store;
